import React, {useState, useContext, useCallback} from 'react';
import {Text, Icon, Button, Anchor} from '@albert-io/atomic';
import {useTracking} from 'react-tracking';

import {ContentDiscoveryContext} from '../ContentDiscoveryProvider.react';

import TopicsModal from './TopicsModal';
// import StandardsModal from './StandardsModal/StandardsModal.react'; //TODO Move to subject selector
import ErrorBoundary from './TopicsModal/ErrorBoundary.react';

const SubjectAndGuideSelector = () => {
  const [showModal, setShowModal] = useState(false);
  const {clearTopicsModal, selectedGuideLevels} = useContext(ContentDiscoveryContext);
  const {trackEvent} = useTracking({event: 'click', type: 'button'});

  const clearHandler = useCallback(() => {
    clearTopicsModal();
    trackEvent({content: 'clear topics'});
  }, [trackEvent, clearTopicsModal]);

  return (
    <div>
      <div className='filter-label'>
        <Text size='s' className='u-flex-grow_1'>
          Subjects & Topics
        </Text>
        {!selectedGuideLevels.isEmpty() && (
          <Anchor
            tabIndex={0}
            className='a-text--size-s u-mar-r_2'
            onClick={clearHandler}
            onKeyPress={(e) => {
              if (e.key === 'Enter') {
                clearHandler();
              }
            }}
          >
            Clear
          </Anchor>
        )}
        <Button
          data-test-id='filter-group__add-subjects'
          size='s'
          variant='outlined'
          onClick={() => {
            setShowModal(true);
            trackEvent({content: 'topics'});
          }}
          className='u-mar-l_auto'
        >
          Add
          <Icon icon={['far', 'circle-plus']} className='u-mar-l_1' />
        </Button>
      </div>

      <ErrorBoundary>
        {showModal && <TopicsModal handleClose={() => setShowModal(false)} />}
      </ErrorBoundary>
    </div>
  );
};

export default SubjectAndGuideSelector;
